// extracted by mini-css-extract-plugin
module.exports = {"App":"App_App__15LM-","App_dark":"App_App_dark__38xF9","App_paper":"App_App_paper__1NykE"};